import React, { useEffect, useState } from 'react'
import ThemeChanger from '../Components/ThemeChanger';
import { CheckCircle, XCircle } from 'lucide-react';
import QuizPageLoader from '../Components/Loaders/QuizPageLoader'
import Bg from '../Components/background/Bg'
import api from '../api'
import { useNavigate, useParams } from 'react-router-dom'
import { useAuth } from '../Context/AuthContext'
import { Ban } from 'lucide-react';

const QuizPage = () => {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [answerSubmitted, setAnswerSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentQuestionCount, setCurrentQuestionCount] = useState(0);
  const [totalQuestions, setTotalQuestions] = useState(null);
  const [questionsPerTopic, setQuestionsPerTopic] = useState(null);
  const [initialTrigger, setInitialTrigger] = useState(false);
  const { roadMapId } = useParams();
  const [reportQuestionGeneration, setReportQuestionGeneration] = useState(0);
  const [reportFlag, setReportFlag] = useState(false)
  const { auth } = useAuth()
  const SECRET_KEY = process.env.REACT_APP_ENCRYPTED_STRING
  const navigate = useNavigate();
  const [question, setQuestion] = useState({
    question: "adsadasd",
    options: ["a", "b", "c", "d"],
    answer: 0,
    topic: ""
  });

  const [reportReason, setReportReason] = useState("");
  const [reportAdditionalInfo, setReportAdditionalInfo] = useState("");

  const [isRoadmapTerminated, setIsRoadmapTerminated] = useState(false);

  const reportContent = [
    {
      label: "Wrong answer is given",
      value: "wrong_answer"
    },
    {
      label: "Question is not generated fully",
      value: "incomplete_question"
    }
  ];

  function decryptString(encryptedString) {
    try {
      if (!encryptedString || typeof encryptedString !== 'string') {
        throw new Error('Invalid input: encryptedString must be a non-empty string');
      }

      const decoded = atob(encryptedString);
      let decrypted = '';

      for (let i = 0; i < decoded.length; i++) {
        const charCode = decoded.charCodeAt(i) ^ SECRET_KEY.charCodeAt(i % SECRET_KEY.length);
        decrypted += String.fromCharCode(charCode);
      }

      return decrypted;
    } catch (error) {
      throw new Error('Decryption failed: ' + error.message);
    }
  }

  const generateReportQuestion = async () => {
    setReportQuestionGeneration(1)
    setLoading(true)
    setSelectedIndex(null);
    setAnswerSubmitted(false);
    api.post("/question/generate-report-question", {
      roadMapId: roadMapId,
      currQuestionCount: currentQuestionCount + 1,
    }).then((res) => {
      if (res.data.statusCode === 401) {
        navigate("/dashboard")
      }
      if (res.data.statusCode === 200) {
        const response = res.data.data;
        response.answer = decryptString(response.answer)
        setQuestion({
          question: response.question,
          options: response.options,
          answer: response.options.indexOf(response.answer),
          topic: response.topic,
        })
      } else {
        navigate("/dashboard")
      }

    }).finally(() => {
      setReportQuestionGeneration(0)
      setLoading(false)
    })
  }

  const generateQuestion = async () => {
    setLoading(true)
    api.post("/question/generate-question", {
      previousQuestion: question?.question || "",
      previousQuestionResult: (selectedIndex === question.answer ? "correct" : "incorrect"),
      roadMapId: roadMapId,
      currQuestionCount: currentQuestionCount + 1,
    }).then((res) => {
      if (res.data.statusCode === 401) {
        navigate("/dashboard")
      }
      if (res.data.statusCode === 200) {
        const response = res.data.data;
        response.answer = decryptString(response.answer)
        setQuestion({
          question: response.question,
          options: response.options,
          answer: response.options.indexOf(response.answer),
          topic: response.topic,
        })
        setCurrentQuestionCount((prev) => prev + 1);
      } else {
        navigate("/dashboard")
      }

    }).finally(() => {
      setLoading(false)
      if (currentQuestionCount >= totalQuestions) {
        api.post("/roadmap/update-roadmap-status", {
          roadMapId: roadMapId,
        }).then((res) => {
          if (res.status === 401) {
            navigate("/dashboard")
          } else {
            navigate(`/loading-roadmap/${roadMapId}`);
          }
        })
      }
      setTimeout(() => {
        setLoading(false)
      }, 500)
    })
  }
  const handleNextQuestionGeneration = () => {
    setSelectedIndex(null);
    setAnswerSubmitted(false);
    generateQuestion()
  };

  useEffect(() => {
    if (!roadMapId) return;
    setLoading(true);
    api.get(`/user/get-roadmap-details?roadMapId=${roadMapId}`).then((res) => {
      const response = res.data.data;
      if (res.data.statusCode == 200) {
        setTotalQuestions(parseInt(response.totalNoQuestions));
        setQuestionsPerTopic(response.questionsPerTopic)
        setCurrentQuestionCount(0)
        setInitialTrigger(true)
      } else {
        console.log("invalid access")
      }

    })
  }, [roadMapId])

  useEffect(() => {
    if (initialTrigger && questionsPerTopic && totalQuestions && currentQuestionCount == 0) {
      setInitialTrigger(false)
      generateQuestion()
    }
  }, [initialTrigger, questionsPerTopic, totalQuestions, currentQuestionCount])
  const handleSubmit = () => {
    setAnswerSubmitted(true);
  };

  const selectOption = (index) => {
    if (!answerSubmitted) {
      setSelectedIndex(index);
    }
  };

  const getOptionClassName = (index) => {
    let baseClasses = "w-full text-left px-4 py-3 border rounded-lg transition-all duration-300 font-medium";

    if (!answerSubmitted) {
      // Before submission
      if (index === selectedIndex) {
        return `${baseClasses} bg-primary text-primary-content border-primary shadow-md`;
      }
      return `${baseClasses} bg-base-100 border-base-300 hover:border-primary hover:bg-base-200 text-base-content`;
    } else {
      // After submission
      if (index === question.answer) {
        // Correct answer - always success color
        return `${baseClasses} bg-success text-success-content border-success shadow-md`;
      } else if (index === selectedIndex) {
        // User's selected wrong answer - error color
        return `${baseClasses} bg-error text-error-content border-error shadow-md`;
      } else {
        // Other unselected options - neutral
        return `${baseClasses} bg-base-200 border-base-300 text-base-content opacity-70`;
      }
    }
  };

  useEffect(() => {
    if (!auth.role || !auth.id) {
      navigate('/login')
    }
  }, [])

  const handleReportSubmit = () => {
    // Call API to submit report
    api.post("/question/report-question", {
      roadMapId: roadMapId,
      reportDetails: {
        reason: reportReason,
        additionalInfo: reportAdditionalInfo,
      },
      questionDetails: question
    }).then((res) => {
      const response = res.data;
      if (response.statusCode === 405) {
        // Set roadmap terminated state to true
        setIsRoadmapTerminated(true);
      } else {
        generateReportQuestion()
        setReportFlag(false);
        setReportReason("");
        setReportAdditionalInfo("");

      }
    }).catch((error) => {
      console.error("Error reporting question:", error);
    });
  };

  if (loading) {
    return (
      <QuizPageLoader currentQuestionCount={currentQuestionCount + 1 - reportQuestionGeneration} totalQuestions={totalQuestions ? totalQuestions : 10} />
    )
  }
  return (
    <div className="min-h-screen bg-base-200 w-screen flex flex-col items-center justify-start p-4 relative ">
      <Bg />
      <div className="w-full max-w-4xl flex flex-col items-center gap-6 absolute z-[10]">
        <div className="w-full flex flex-col md:flex-row md:justify-between items-center gap-3">
          <div className="bg-base-100 p-3 text-md font-poppins border border-neutral rounded-lg w-full md:w-auto text-center shadow-md">
            <p>Question No: <span className="text-info font-semibold">{currentQuestionCount}</span> / {totalQuestions}</p>
          </div>
          <div className="bg-base-100 p-3 text-md font-poppins border border-neutral rounded-lg w-full md:w-auto text-center shadow-md">
            <p>Topic: <span className="text-primary font-semibold">{question.topic}</span></p>
          </div>
          <div className="bg-base-100 p-3 text-md font-poppins border border-neutral rounded-lg w-full md:w-auto text-center shadow-md">
            <ThemeChanger />
          </div>
        </div>


        <div className="w-full bg-base-100 border border-base-300 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow">
          <h2 className="text-xl font-bold mb-6 text-base-content leading-relaxed">
            {question.question}
          </h2>

          <div className="flex flex-col gap-3">
            {question.options.map((option, index) => (
              <button
                key={index}
                onClick={() => selectOption(index)}
                className={getOptionClassName(index)}
                disabled={answerSubmitted}
              >
                <span className="font-semibold opacity-70 mr-3">
                  {String.fromCharCode("A".charCodeAt(0) + index)}.
                </span>
                {option}
              </button>
            ))}
          </div>

          {/* Action Button */}
          <div className="flex justify-center items-center mt-6 gap-4">
            <button
              className={`btn font-semibold transition-all duration-200 transform hover:-translate-y-0.5 ${selectedIndex === null
                ? 'btn-disabled'
                : answerSubmitted
                  ? 'btn-success'
                  : 'btn-primary'
                }`}
              disabled={selectedIndex === null}
              onClick={answerSubmitted ? handleNextQuestionGeneration : handleSubmit}
            >
              {answerSubmitted ? "Generate Next Question" : "Submit Answer"}
            </button>
            <button className='btn btn-error' onClick={() => setReportFlag(true)}>
              Report
            </button>
          </div>

          {/* Feedback Message */}
          {answerSubmitted && (
            <div className="mt-4 text-center">
              {selectedIndex === question.answer ? (
                <div className="alert alert-success shadow-lg">
                  <div className="flex justify-center items-center gap-3">
                    <CheckCircle className="stroke-current flex-shrink-0 h-6 w-6" />
                    <span className="font-semibold">Correct! Well done!</span>
                  </div>
                </div>
              ) : (
                <div className="alert alert-error shadow-lg">
                  <div className="flex justify-center items-center gap-3">
                    <XCircle className="stroke-current flex-shrink-0 h-6 w-6" />
                    <span className="font-semibold">
                      Incorrect. The correct answer is {String.fromCharCode("A".charCodeAt(0) + question.answer)}.
                    </span>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {
        reportFlag && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div className="bg-base-100 p-6 rounded-lg shadow-xl w-full max-w-md mx-4">
              {isRoadmapTerminated ? (
                // Show termination message
                <div className="flex flex-col items-center text-center">
                  <div className="mb-6 text-error">
                    <Ban size={64} className="mx-auto mb-4" />
                    <h3 className="font-bold text-xl mb-4">Roadmap Terminated</h3>
                    <p className="text-base-content">
                      Since more than 5 questions are reported, the roadmap is terminated.
                    </p>
                  </div>
                  <button
                    className="btn btn-primary"
                    onClick={() => navigate("/dashboard")}
                  >
                    Continue
                  </button>
                </div>
              ) : (
                // Regular report form
                <>
                  <div className="flex justify-between items-center mb-4">
                    <h3 className="font-bold text-lg">Report Question</h3>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() => {
                        setReportFlag(false);
                        setReportReason("");
                        setReportAdditionalInfo("");
                      }}
                    >
                      ✕
                    </button>
                  </div>

                  {/* Report reason options */}
                  <div className="mb-4">
                    <p className="font-medium mb-3">Select issue type:</p>
                    <div className="grid grid-cols-1 gap-3">
                      {reportContent.map((item) => (
                        <button
                          key={item.value}
                          className={`btn ${reportReason === item.value ? 'btn-primary' : 'btn-outline'} justify-start normal-case`}
                          onClick={() => setReportReason(item.value)}
                        >
                          <Ban size={18} className="mr-2" />
                          {item.label}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Additional information */}
                  <div className="mb-6">
                    <label className="font-medium block mb-2">Additional Information (Optional)</label>
                    <textarea
                      className="textarea textarea-bordered w-full h-24"
                      placeholder="Please provide any additional details..."
                      value={reportAdditionalInfo}
                      onChange={(e) => setReportAdditionalInfo(e.target.value)}
                    ></textarea>
                  </div>

                  <div className="flex justify-end gap-3">
                    <button
                      className="btn btn-ghost"
                      onClick={() => {
                        setReportFlag(false);
                        setReportReason("");
                        setReportAdditionalInfo("");
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      disabled={!reportReason}
                      onClick={handleReportSubmit}
                    >
                      Submit Report
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )
      }
    </div>
  );
};

export default QuizPage;